module.exports = __webpack_public_path__ + "static/img/li_6.e4c495d.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/li_6.jpeg
// module id = 23H/
// module chunks = 6